// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__39mGo","selects":"Documents_selects__3x2W-"};